import { useState, useEffect } from "react";
import ProductCard from "../../components/ProductCard";
import { Search } from "lucide-react";
import { GetallProduct } from "../../api";

function ProductPage() {
  const [search, setSearch] = useState("");
  const [category, setCategory] = useState("All");
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  const getProducts = async () => {
    try {
      const response = await GetallProduct();

      if (response.data.success) {
        setProducts(response.data.products);
      }
    } catch (error) {
      console.log("Error fetching products:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getProducts();
  }, []);

  const filteredProducts = products.filter((product) => {
    const matchSearch = product.title
      ?.toLowerCase()
      .includes(search.toLowerCase());

    const matchCategory =
      category === "All" ||
      product.category === category;

    return matchSearch && matchCategory;
  });

  return (
    <section className="bg-gray-50 min-h-screen py-10">
      <div className="max-w-7xl mx-auto px-5">

        {/* Header */}
        <div className="text-center mb-10">
          <h1 className="text-5xl font-bold">
            Our Products
          </h1>

          <p className="text-gray-500 mt-3">
            Premium Hydroponic Solutions for Modern Farming
          </p>
        </div>

        {/* Search & Filter */}
        <div className="flex flex-col md:flex-row gap-4 mb-8">
          <div className="relative flex-1">
            <Search
              size={18}
              className="absolute left-4 top-4 text-gray-400"
            />

            <input
              type="text"
              placeholder="Search Products..."
              value={search}
              onChange={(e) =>
                setSearch(e.target.value)
              }
              className="w-full border rounded-xl pl-11 py-3"
            />
          </div>

          <select
            value={category}
            onChange={(e) =>
              setCategory(e.target.value)
            }
            className="border rounded-xl px-4 py-3"
          >
            <option value="All">All</option>
            <option value="Hydroponic Systems">
              Hydroponic Systems
            </option>
            <option value="Lighting">
              Lighting
            </option>
            <option value="Nutrients">
              Nutrients
            </option>
            <option value="Seeds">
              Seeds
            </option>
          </select>
        </div>

        {/* Loading */}
        {loading ? (
          <div className="text-center py-20">
            Loading Products...
          </div>
        ) : (
          <>
            {/* Products */}
            <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
              {filteredProducts.map((product) => (
                <ProductCard
                  key={product._id}
                  product={product}
                />
              ))}
            </div>

            {/* No Products */}
            {filteredProducts.length === 0 && (
              <div className="text-center py-20">
                <h3 className="text-2xl font-semibold text-gray-500">
                  No Products Found
                </h3>
              </div>
            )}
          </>
        )}
      </div>
    </section>
  );
}

export default ProductPage;